import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      reserva: 'reservas/_id/getActual'
    }),
    documentacionRechazada () {
      return this.reserva.estadoDocumentacion.codigoEstadoDocumentacion === 91
    },
    documentacionRevisando () {
      return this.reserva.estadoDocumentacion.codigoEstadoDocumentacion === 5
    },
    documentacionRellenada () {
      return this.reserva.estadoDocumentacion.codigoEstadoDocumentacion === 3
    },
    documentacionVer () {
      return this.reserva.estadoDocumentacion.codigoEstadoDocumentacion === 10
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/estadosReserva/estadoDocumentacion.js